/* eslint-disable react/prop-types */
/**
 * Pass H — engagement calibration coverage card.
 *
 * Renders the ``engagement_calibration_summary`` block from the
 * campaign detail payload as a small headline KPI card. Two badge
 * rows underneath show the calibrated / kinematic split with
 * tabular numerals and defence-palette tokens only.
 *
 * ``summary === null`` is the in-progress / pre-Pass-G empty state.
 * UK spelling throughout.
 */
import AirframeAeroBadge from "@/components/sim/AirframeAeroBadge";
import { DEFENCE_PALETTE } from "@/components/phase19/placementUtils";


export default function EngagementCalibrationCard({ summary }) {
    if (summary == null) {
        return (
            <section
                className="rounded-md border p-4 text-sm"
                style={{
                    borderColor: DEFENCE_PALETTE.steelGray,
                    color: DEFENCE_PALETTE.steelGray,
                }}
                data-testid="engagement-calibration-card-empty"
            >
                <h3
                    className="text-[11px] font-semibold uppercase "
                    style={{ color: DEFENCE_PALETTE.navy }}
                >
                    Engagement calibration coverage
                </h3>
                <p
                    className="mt-2 leading-relaxed"
                    style={{ color: DEFENCE_PALETTE.steelGray }}
                >
                    Calibration coverage not yet available — campaign in
                    progress.
                </p>
            </section>
        );
    }

    const {
        total_engagements: total,
        aero_calibrated_pair_true: nCal,
        aero_calibrated_pair_false: nKin,
        pct_calibrated: pct,
    } = summary;

    return (
        <section
            className="rounded-md border p-4 text-sm"
            style={{ borderColor: DEFENCE_PALETTE.steelGray }}
            data-testid="engagement-calibration-card"
        >
            <h3
                className="text-[11px] font-semibold uppercase"
                style={{ color: DEFENCE_PALETTE.navy }}
            >
                Engagement calibration coverage
            </h3>
            <p
                className="mt-2 leading-relaxed"
                style={{
                    color: DEFENCE_PALETTE.navy,
                    fontVariantNumeric: "tabular-nums",
                }}
                data-testid="engagement-calibration-card-headline"
            >
                <span
                    className="text-base font-semibold"
                >{nCal.toLocaleString()}</span>{" "}
                of{" "}
                <span
                    className="text-base font-semibold"
                >{total.toLocaleString()}</span>{" "}
                engagements ran on 6-DoF aero{" "}
                <span
                    className="font-semibold"
                    style={{ color: DEFENCE_PALETTE.teal }}
                >({pct.toFixed(2)}%)</span>
            </p>
            <div className="mt-3 flex items-center gap-3">
                <div
                    className="flex items-center gap-2"
                    data-testid="engagement-calibration-card-calibrated-row"
                >
                    <AirframeAeroBadge aeroCalibrated={true} />
                    <span
                        className="text-xs"
                        style={{
                            color: DEFENCE_PALETTE.navy,
                            fontVariantNumeric: "tabular-nums",
                        }}
                    >
                        {nCal.toLocaleString()}
                    </span>
                </div>
                <div
                    className="flex items-center gap-2"
                    data-testid="engagement-calibration-card-kinematic-row"
                >
                    <AirframeAeroBadge aeroCalibrated={false} />
                    <span
                        className="text-xs"
                        style={{
                            color: DEFENCE_PALETTE.navy,
                            fontVariantNumeric: "tabular-nums",
                        }}
                    >
                        {nKin.toLocaleString()}
                    </span>
                </div>
            </div>
        </section>
    );
}
